import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import CountUp from "react-countup";
import { dummyStats } from "../data/dummyStats";

export default function Statistics() {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const [stats, setStats] = useState({
        trusted_clients: 0,
        finished_projects: 0,
        visited_conferences: 0,
        years_of_experience: 0,
    });
    const sectionRef = useRef(null);

    useEffect(() => {
        setStats(dummyStats);
    }, []);

    useEffect(() => {
        const currentSection = sectionRef.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.3 }
        );

        if (currentSection) {
            observer.observe(currentSection);
        }

        return () => {
            if (currentSection) {
                observer.unobserve(currentSection);
            }
        };
    }, []);

    return (
        <section ref={sectionRef} className="d-none py-[40px] bg-[#242830]">
            <div className="f-col container flex flex-wrap justify-between items-center">
                <div className="flex items-center justify-center flex-col text-center text-white">
                    <div className="font-bold text-[35px] text-[#3896BE]">
                        {isVisible ? (
                            <CountUp end={stats.trusted_clients} duration={6} />
                        ) : (
                            `${stats.trusted_clients}+`
                        )}
                    </div>
                    <div className="capitalize font-bold">{t("Trusted Clients")}</div>
                </div>

                <div className="flex items-center justify-center flex-col text-center text-white">
                    <div className="font-bold text-[35px] text-[#3896BE]">
                        {isVisible ? (
                            <CountUp end={stats.finished_projects} duration={6} />
                        ) : (
                            `${stats.finished_projects}+`
                        )}
                    </div>
                    <div className="capitalize font-bold">{t("Finished Projects")}</div>
                </div>

                <div className="flex items-center justify-center flex-col text-center text-white">
                    <div className="font-bold text-[35px] text-[#3896BE]">
                        {isVisible ? (
                            <CountUp end={stats.visited_conferences} duration={6} />
                        ) : (
                            `${stats.visited_conferences}+`
                        )}
                    </div>
                    <div className="capitalize font-bold">{t("Visited Conferences")}</div>
                </div>

                <div className="flex items-center justify-center flex-col text-center text-white">
                    <div className="font-bold text-[35px] text-[#3896BE]">
                        {isVisible ? (
                            <CountUp end={stats.years_of_experience} duration={6} />
                        ) : (
                            `${stats.years_of_experience}+`
                        )}
                    </div>
                    <div className="capitalize font-bold">{t("Years Of Experience")}</div>
                </div>
            </div>
        </section>
    );
}